'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Fullstory = exports.Fullstory = function () {
  function Fullstory() {
    _classCallCheck(this, Fullstory);
  }

  _createClass(Fullstory, null, [{
    key: 'inject',
    value: function inject() {
      /* eslint-disable */
      // prettier-ignore
      (function (m, n, e, t, l, o, g, y) {
        if (e in m) {
          if (m.console && m.console.log) {
            m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
          }

          return;
        }

        g = m[e] = function (a, b) {
          g.q ? g.q.push([a, b]) : g._api(a, b);
        };

        g.q = [];
        o = n.createElement(t);
        o.async = 1;
        o.src = 'https://' + _fs_host + '/s/fs.js';
        y = n.getElementsByTagName(t)[0];
        y.parentNode.insertBefore(o, y);

        g.identify = function (i, v) {
          g(l, {
            uid: i
          });
          if (v) g(l, v);
        };

        g.setUserVars = function (v) {
          g(l, v);
        };

        g.event = function (i, v) {
          g('event', {
            n: i,
            p: v
          });
        };

        g.shutdown = function () {
          g("rec", !1);
        };

        g.restart = function () {
          g("rec", !0);
        };

        g.consent = function (a) {
          g("consent", !arguments.length || a);
        };

        g.identifyAccount = function (i, v) {
          o = 'account';
          v = v || {};
          v.acctId = i;
          g(o, v);
        };

        g.clearUserCookie = function () {};
      })(window, document, window['_fs_namespace'], 'script', 'user');
      /* eslint-enable */

    }
  }, {
    key: 'initialize',
    value: function initialize(_ref) {
      var org = _ref.org,
          _ref$debug = _ref.debug,
          debug = _ref$debug === undefined ? false : _ref$debug,
          _ref$namespace = _ref.namespace,
          namespace = _ref$namespace === undefined ? 'FS' : _ref$namespace,
          _ref$host = _ref.host,
          host = _ref$host === undefined ? 'fullstory.com' : _ref$host;

      if (typeof org !== 'string') {
        throw new Error('org must be defined');
      }

      var fullstory = window[namespace];

      if (fullstory === undefined) {
        window['_fs_org'] = org;
        window['_fs_debug'] = debug;
        window['_fs_host'] = host;
        window['_fs_namespace'] = namespace;
        Fullstory.inject();
      }
    }
  }]);

  return Fullstory;
}();